var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CustomerInfoModal',{attrs:{"id":'customerInfo',"closeModal":_vm.closeModal,"customer":_vm.customer}}),_c('AddressWarningModal',{attrs:{"id":'addressWarning',"closeModal":_vm.closeModal,"continue":_vm.handleCreateInvoice}}),(_vm.duplicate)?_c('SuccessModal',{attrs:{"id":'invoiceCreationSuccess',"title":`Invoice Duplicated`,"message":`Invoice Duplicated Successfully
			`,"onSuccess":_vm.backToInvoice}}):_c('SuccessModal',{attrs:{"id":'invoiceCreationSuccess',"title":`${_vm.status ? 'New Invoice Created' : 'Invoice Updated'}`,"message":`${
			_vm.status
				? 'Invoice Created Successfully'
				: 'Invoice Updated Successfully'
		}`,"onSuccess":_vm.backToInvoice}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }